'use strict';

import 'document-register-element';
import dispatcher from '../dispatcher';
import store from './slider.store';



class Button extends HTMLButtonElement {
  constructor(self) {
    self = super(self);
    self.init.call(self);
  }
  init() {
    this._hidden = false;

    this.subscribe = e => this._subscribe(e);
  }
  connectedCallback() {
    console.log(1231)
    this._slider = this.dataset.slider;
    this._direction = this.dataset.direction;
    this._disable = this.classList.contains('disabled');

    this.addEventListener('click', this._click);

    this._subscribe(store.getData());
    store.eventEmitter.subscribe(this.subscribe);
  }
  disconnectedCallback() {
    store.eventEmitter.unsubscribe(this.subscribe);
  }

  _click() {
    dispatcher.dispatch({
      type: 'slider-navigate',
      _module: 'slider-button.component',
      slider: this._slider,
      direction: this._direction
    })
  }
  _subscribe(e) {
    if (!e.items.hasOwnProperty(this._slider)) return;

    if ((e.type === 'slider-emit' || e.type === undefined)) {
      let set = false;
      let slider = e.items[this._slider];

      if (this._direction === 'prev') {
        set = slider.activeStart === 0;
      } else if (this._direction === 'next') {
        set = slider.total === slider.activeStart + slider.activeCount;
      }

      if (set && !this._disable) {
        this.classList.add('disabled');
        this._disable = true;
      } else if (!set && this._disable) {
        this.classList.remove('disabled');
        this._disable = false;
      }

      this._setHide(slider);
    } else if ('slider-enable-emit') {
      this._setHide(e.items[this._slider])
    }
  }

  _setHide(slider) {
    if (slider.disabled) {
      if (!this._hidden){
        this.classList.add('hidden');
        this._hidden = true;
      }
    } else {
      if (this._hidden){
        this.classList.remove('hidden');
        this._hidden = false;
      }
    }
  }
}


window.customElements.define('slider-button', Button, {extends: 'button'});
